// Mock data for DARWAZAY GARMYAN luxury residential website

export const translations = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      projects: "Projects",
      about: "About Us",
      services: "Services",
      media: "Media",
      careers: "Careers",
      contact: "Contact"
    },
    // Homepage
    hero: {
      title: "Welcome to the Gateway of Kurdistan Development",
      subtitle: "Darwazay Garmyan is a pioneer in construction and development of residential projects with unparalleled service and quality in the Kurdistan Region.",
      exploreCTA: "Explore Projects",
      contactCTA: "Contact Us"
    },
    metrics: {
      completedProjects: "Completed Projects",
      residentialProjects: "Residential Projects",
      totalConstructions: "Total Constructions",
      yearsOfService: "Years of Service"
    },
    featuredProjects: {
      title: "Residential Projects",
      subtitle: "Completely different residential projects",
      viewDetails: "View Details"
    },
    cta: {
      title: "We're Happy to Connect With You",
      button: "Get In Touch"
    },
    // Projects
    projects: {
      title: "Our Projects",
      filters: {
        all: "All",
        residential: "Residential",
        villas: "Villas",
        apartments: "Apartments",
        ongoing: "Ongoing",
        completed: "Completed"
      }
    },
    // About
    about: {
      hero: "About Darwazay Garmyan",
      subtitle: "Building the Future of Kurdistan",
      story: {
        title: "Our Story",
        content: "Darwazay Garmyan is a pioneering company in the Kurdistan Region with expertise and excellence in construction and development. Our main goal is to participate in development projects and infrastructure reconstruction of Kurdistan."
      },
      vision: {
        title: "Our Vision",
        content: "To be the leading residential developer in Kurdistan Region, setting new standards for quality, innovation, and community development."
      },
      mission: {
        title: "Our Mission",
        content: "Deliver exceptional residential communities that enhance quality of life through superior construction, thoughtful design, and sustainable development practices."
      },
      values: {
        title: "Our Values",
        quality: "Quality Excellence",
        qualityDesc: "Committed to the highest standards in every project",
        innovation: "Innovation",
        innovationDesc: "Embracing new technologies and modern construction methods",
        integrity: "Integrity",
        integrityDesc: "Building trust through transparency and honest dealings",
        sustainability: "Sustainability",
        sustainabilityDesc: "Creating environmentally responsible communities"
      }
    },
    // Services
    services: {
      title: "Our Services",
      subtitle: "Comprehensive construction and development solutions",
      residential: {
        title: "Residential Building",
        description: "Premium residential communities with modern amenities and quality construction"
      },
      infrastructure: {
        title: "Infrastructure Development",
        description: "Complete infrastructure solutions including utilities, roads, and community facilities"
      },
      roads: {
        title: "Road Construction",
        description: "Modern road construction and maintenance for improved connectivity"
      },
      community: {
        title: "Community Development",
        description: "Integrated community planning and development for sustainable living"
      }
    },
    // Contact
    contact: {
      title: "Contact Us",
      subtitle: "Get in touch with our team",
      form: {
        name: "Your Name",
        phone: "Phone Number",
        email: "Email Address",
        message: "Your Message",
        project: "Interested Project",
        submit: "Send Message",
        success: "Thank you! We'll contact you soon.",
        error: "Please fill all required fields"
      },
      info: {
        address: "Sulaymaniyah - Salim Street - Under Khosraw Khall Bridge - Near Rêkxistin 1 Roundabout",
        phone: "Phone Numbers",
        email: "Email"
      }
    },
    // Careers
    careers: {
      title: "Join Our Team",
      subtitle: "Be part of building Kurdistan's future",
      filters: {
        all: "All Positions",
        engineering: "Engineering",
        management: "Management",
        sales: "Sales",
        support: "Support"
      },
      apply: "Apply Now"
    },
    // Media
    media: {
      title: "Virtual Tours & Media",
      subtitle: "Explore our projects",
      gallery: "Project Gallery",
      videos: "Videos"
    },
    // Footer
    footer: {
      about: "Darwazay Garmyan is a leading residential construction and development company in the Kurdistan Region, specializing in quality residential communities.",
      quickLinks: "Quick Links",
      projects: "Projects",
      contact: "Contact Information",
      rights: "All Rights Reserved © 2026 Darwazay Garmyan"
    },
    // Project Detail Page
    projectDetail: {
      projectInfo: "Project Information",
      location: "Location",
      status: "Status",
      units: "Units",
      type: "Type",
      ongoing: "Ongoing",
      completed: "Completed",
      residential: "Residential",
      interested: "Interested? Contact Us",
      aboutProject: "About This Project",
      unitTypes: "Unit Types",
      bedrooms: "Bedrooms",
      viewFloorPlan: "View Floor Plan",
      selectUnitType: "Select Unit Type",
      projectGallery: "Project Gallery",
      exterior: "Exterior",
      interior: "Interior",
      amenities: "Amenities",
      downloadBrochure: "Download Brochure",
      typeLabel: "Type"
    },
    // Infrastructure Projects
    infrastructure: {
      sectionTitle: "Infrastructure Projects",
      sectionSubtitle: "Building the Foundation of Progress",
      viewProject: "View Project",
      projectOverview: "Project Overview",
      projectTimeline: "Project Timeline",
      keyObjectives: "Key Objectives",
      designImplementation: "Design & Implementation",
      partnership: "Public–Private Partnership",
      communityImpact: "Community Impact",
      results: "Results & Achievements",
      viewOnMap: "View on Map",
      projectGallery: "Project Gallery",
      beforeAfter: "Before & After"
    },
    // Social Projects
    social: {
      sectionTitle: "Social Projects",
      sectionSubtitle: "Caring for Our Community",
      viewProject: "View Project",
      projectOverview: "Project Overview",
      ourMission: "Our Mission",
      ourServices: "Our Services",
      ourImpact: "Our Impact",
      ourValues: "Our Values",
      completed: "Completed"
    }
  },
  ar: {
    // Navigation (Arabic)
    nav: {
      home: "الرئيسية",
      projects: "المشاريع",
      about: "من نحن",
      services: "الخدمات",
      media: "الوسائط",
      careers: "الوظائف",
      contact: "اتصل بنا"
    },
    // Homepage
    hero: {
      title: "مرحباً بكم في بوابة تطوير كردستان",
      subtitle: "درواز كرميان رائدة في البناء وتطوير المشاريع السكنية مع خدمة وجودة لا مثيل لهما في إقليم كردستان",
      exploreCTA: "استكشف المشاريع",
      contactCTA: "اتصل بنا"
    },
    metrics: {
      completedProjects: "المشاريع المنجزة",
      residentialProjects: "المشاريع السكنية",
      totalConstructions: "إجمالي البناءات",
      yearsOfService: "سنوات الخدمة"
    },
    featuredProjects: {
      title: "المشاريع السكنية",
      subtitle: "مشاريع سكنية مختلفة تماماً",
      viewDetails: "عرض التفاصيل"
    },
    cta: {
      title: "نحن سعداء للتواصل معك",
      button: "تواصل معنا"
    },
    projects: {
      title: "مشاريعنا",
      filters: {
        all: "الكل",
        residential: "سكني",
        villas: "فلل",
        apartments: "شقق",
        ongoing: "جاري التنفيذ",
        completed: "مكتمل"
      }
    },
    about: {
      hero: "عن درواز كرميان",
      subtitle: "بناء مستقبل كردستان",
      story: {
        title: "قصتنا",
        content: "درواز كرميان شركة رائدة في إقليم كردستان ذات خبرة وتميز في البناء والتطوير. هدفنا الرئيسي هو المشاركة في مشاريع التنمية وإعادة بناء البنية التحتية لكردستان"
      },
      vision: {
        title: "رؤيتنا",
        content: "أن نكون المطور السكني الرائد في إقليم كردستان، ووضع معايير جديدة للجودة والابتكار والتنمية المجتمعية"
      },
      mission: {
        title: "مهمتنا",
        content: "تقديم مجتمعات سكنية استثنائية تعزز جودة الحياة من خلال البناء المتميز والتصميم المدروس وممارسات التنمية المستدامة"
      },
      values: {
        title: "قيمنا",
        quality: "التميز في الجودة",
        qualityDesc: "والالتزام بأعلى المعايير في كل مشروع.",
        innovation: "الابتكار",
        innovationDesc: "تبني التقنيات الجديدة وأساليب البناء الحديثة",
        integrity: "النزاهة",
        integrityDesc: "بناء الثقة من خلال الشفافية والتعاملات الصادقة",
        sustainability: "الاستدامة",
        sustainabilityDesc: "إنشاء مجتمعات مسؤولة بيئيًا ومستدامة للأجيال القادمة."
      }
    },
    services: {
      title: "خدماتنا",
      subtitle: "حلول شاملة للبناء والتطوير",
      residential: {
        title: "البناء السكني",
        description: "مجتمعات سكنية متميزة مع وسائل راحة حديثة و بناء بأعلى الجودة"
      },
      infrastructure: {
        title: "تطوير البنية التحتية",
        description: "حلول بنية تحتية متكاملة تشمل الطرق والمرافق والخدمات المجتمعية."
      },
      roads: {
        title: "بناء الطرق",
        description: "بناء وصيانة طرق حديثة لتحسين الاتصال"
      },
      community: {
        title: "التنمية المجتمعية",
        description: "تخطيط وتطوير مجتمعي متكامل للمعيشة المستدامة"
      }
    },
    contact: {
      title: "اتصل بنا",
      subtitle: "تواصل مع فريقنا",
      form: {
        name: "اسمك",
        phone: "رقم الهاتف",
        email: "عنوان البريد الإلكتروني",
        message: "رسالتك",
        project: "المشروع المهتم به",
        submit: "إرسال الرسالة",
        success: "شكراً لك! سنتواصل معك قريباً",
        error: "يرجى ملء جميع الحقول المطلوبة"
      },
      info: {
        address: "العنوان",
        phone: "أرقام الهاتف",
        email: "البريد الإلكتروني"
      }
    },
    careers: {
      title: "انضم إلى فريقنا",
      subtitle: "كن جزءاً من بناء مستقبل كردستان",
      filters: {
        all: "جميع الوظائف",
        engineering: "الهندسة",
        management: "الإدارة",
        sales: "المبيعات",
        support: "الدعم"
      },
      apply: "قدم الآن"
    },
    media: {
      title: "جولات افتراضية ووسائط",
      subtitle: "استكشف مشاريعنا",
      gallery: "معرض المشاريع",
      videos: "فيديوهات"
    },
    footer: {
      about: "درواز كرميان شركة رائدة في البناء والتطوير السكني في إقليم كردستان، متخصصة في مجتمعات سكنية عالية الجودة",
      quickLinks: "روابط سريعة",
      projects: "المشاريع",
      contact: "معلومات الاتصال",
      rights: "جميع الحقوق محفوظة © 2026 درواز كرميان"
    },
    // Project Detail Page
    projectDetail: {
      projectInfo: "معلومات المشروع",
      location: "الموقع",
      status: "الحالة",
      units: "الوحدات",
      type: "النوع",
      ongoing: "جاري التنفيذ",
      completed: "مكتمل",
      residential: "سكني",
      interested: "هل انت مهتم؟ تواصل معنا",
      aboutProject: "عن هذا المشروع",
      unitTypes: "أنواع الوحدات",
      bedrooms: "غرف نوم",
      viewFloorPlan: "عرض مخطط الطابق",
      selectUnitType: "اختر نوع الوحدة",
      projectGallery: "معرض المشروع",
      exterior: "خارجي",
      interior: "داخلي",
      amenities: "المرافق الحضرية",
      downloadBrochure: "تحميل الكتيب",
      typeLabel: "النوع"
    },
    // Infrastructure Projects
    infrastructure: {
      sectionTitle: "مشاريع البنية التحتية",
      sectionSubtitle: "بناء أساس التقدم",
      viewProject: "عرض المشروع",
      projectOverview: "نظرة عامة على المشروع",
      projectTimeline: "الجدول الزمني للمشروع",
      keyObjectives: "الأهداف الرئيسية",
      designImplementation: "التصميم والتنفيذ",
      partnership: "الشراكة بين القطاعين العام والخاص",
      communityImpact: "الأثر المجتمعي",
      results: "النتائج والإنجازات",
      viewOnMap: "عرض على الخريطة",
      projectGallery: "معرض المشروع",
      beforeAfter: "قبل وبعد"
    },
    // Social Projects
    social: {
      sectionTitle: "المشاريع الاجتماعية",
      sectionSubtitle: "رعاية مجتمعنا",
      viewProject: "عرض المشروع",
      projectOverview: "نظرة عامة على المشروع",
      ourMission: "مهمتنا",
      ourServices: "خدماتنا",
      ourImpact: "أثرنا",
      ourValues: "قيمنا",
      completed: "مكتمل"
    }
  },
  ku: {
    // Navigation (Kurdish)
    nav: {
      home: "سەرەتا",
      projects: "پڕۆژەکان",
      about: "دەربارەمان",
      services: "خزمەتگوزارییەکان",
      media: "گالەری",
      careers: "هەلی کار",
      contact: "پەیوەندی"
    },
    // Homepage
    hero: {
      title: "بەخێربێن بۆ دەروازەی گەشەپێدانی کوردستان",
      subtitle: "دەروازەی گەرمیان پێشەنگە لە بیناسازی و گەشەپێدانی پڕۆژە نیشتەجێبوونەکان بە خزمەتگوزاری و کوالیتی بێ هاوتا لە هەرێمی کوردستان",
      exploreCTA: "پڕۆژەکان ببینە",
      contactCTA: "پەیوەندیمان پێوە بکە"
    },
    metrics: {
      completedProjects: "پڕۆژە تەواوکراوەکان",
      residentialProjects: "پڕۆژە نیشتەجێبوونەکان",
      totalConstructions: "کۆی بیناسازییەکان",
      yearsOfService: "ساڵی خزمەتگوزاری"
    },
    featuredProjects: {
      title: "پڕۆژە نیشتەجێبوونەکان",
      subtitle: "پڕۆژە نیشتەجێبوونی جیاواز بە تەواوی",
      viewDetails: "وردەکارییەکان ببینە"
    },
    cta: {
      title: "خۆشحاڵین بە پەیوەندیکردن لەگەڵتان",
      button: "پەیوەندیمان پێوە بکە"
    },
    projects: {
      title: "پڕۆژەکانمان",
      filters: {
        all: "هەموو",
        residential: "نیشتەجێبوون",
        villas: "ڤێلاکان",
        apartments: "شوقەکان",
        ongoing: "بەردەوامە",
        completed: "تەواوکراوە"
      }
    },
    about: {
      hero: "دەربارەی دەروازەی گەرمیان",
      subtitle: "داهاتووی کوردستان بنیاد دەنێین",
      story: {
        title: "چیرۆکەکەمان",
        content: "دەروازەی گەرمیان کۆمپانیایەکی پێشەنگە لە هەرێمی کوردستان بە شارەزایی و باشی لە بیناسازی و گەشەپێدان. ئامانجی سەرەکیمان بەشداریکردنە لە پڕۆژەکانی گەشەپێدان و بنیاتنانەوەی ژێرخانی کوردستان"
      },
      vision: {
        title: "ئامانجمان",
        content: "بوون بە پێشەنگی گەشەپێدەری نیشتەجێبوون لە هەرێمی کوردستان، و دانانی پێوەری نوێ بۆ کوالیتی و داهێنان و گەشەپێدانی کۆمەڵایەتی"
      },
      mission: {
        title: "ئەرکەکەمان",
        content: "دابینکردنی کۆمەڵگەی نیشتەجێبوونی تایبەت کە کوالیتی ژیان بەرز دەکاتەوە لە ڕێگەی بیناسازی نایاب و دیزاینی وریا و شێوازی گەشەپێدانی بەردەوام"
      },
      values: {
        title: "بەهاکانمان",
        quality: "باشی لە کوالیتی",
        qualityDesc: "پابەندین بە بەرزترین پێوەرەکان لە هەموو پڕۆژەیەکدا",
        innovation: "داهێنان",
        innovationDesc: "بەکارهێنانی تەکنەلۆژیای نوێ و شێوازی بیناسازی مۆدێرن",
        integrity: "دروستی",
        integrityDesc: "بنیاتنانی متمانە لە ڕێگەی ڕوونی و مامەڵەی ڕاستگۆیانە",
        sustainability: "بەردەوامی",
        sustainabilityDesc: "دروستکردنی کۆمەڵگای بەرپرسیارانە لە ڕووی ژینگەوە"
      }
    },
    services: {
      title: "خزمەتگوزارییەکانمان",
      subtitle: "چارەسەری گشتگیری بیناسازی و گەشەپێدان",
      residential: {
        title: "بیناسازی نیشتەجێبوون",
        description: "کۆمەڵگەی نیشتەجێبوونی تایبەت بە ئاسانکارییەکانی مۆدێرن و بیناسازی کوالیتی بەرز"
      },
      infrastructure: {
        title: "گەشەپێدانی ژێرخان",
        description: "چارەسەری تەواوی ژێرخان لەخۆگرتووی بەکارهێنانەکان و ڕێگاکان و ئاسانکارییەکانی کۆمەڵایەتی"
      },
      roads: {
        title: "بیناسازی ڕێگا",
        description: "بیناسازی و چاککردنەوەی ڕێگای مۆدێرن بۆ باشترکردنی پەیوەندی"
      },
      community: {
        title: "گەشەپێدانی کۆمەڵایەتی",
        description: "پلاندانان و گەشەپێدانی کۆمەڵایەتی یەکگرتوو بۆ ژیانی بەردەوام"
      }
    },
    contact: {
      title: "پەیوەندیمان پێوە بکە",
      subtitle: "لەگەڵ تیمەکەمان پەیوەندی بکە",
      form: {
        name: "ناوت",
        phone: "ژمارەی تەلەفۆن",
        email: "ناونیشانی ئیمەیڵ",
        message: "پەیامەکەت",
        project: "پڕۆژەی خۆشەویست",
        submit: "ناردنی پەیام",
        success: "سوپاس! زوو پەیوەندیت پێوە دەکەین",
        error: "تکایە هەموو خانەکانی پێویست پڕ بکەوە"
      },
      info: {
        address: "ناونیشان",
        phone: "ژمارە تەلەفۆنەکان",
        email: "ئیمەیڵ"
      }
    },
    careers: {
      title: "بەشداری لە تیمەکەمان بکە",
      subtitle: "بەشێک بە لە بنیاتنانی داهاتووی کوردستان",
      filters: {
        all: "هەموو پێگەکان",
        engineering: "ئەندازیاری",
        management: "بەڕێوەبردن",
        sales: "فرۆشتن",
        support: "پشتیوانی"
      },
      apply: "داواکاری بکە ئێستا"
    },
    media: {
      title: "گەشتی ڤیرچووەڵ و میدیا",
      subtitle: "پڕۆژەکانمان بگەڕێ",
      gallery: "گالەریی پڕۆژە",
      videos: "ڤیدیۆکان"
    },
    footer: {
      about: "دەروازەی گەرمیان کۆمپانیایەکی پێشەنگی بیناسازی و گەشەپێدانی نیشتەجێبوونە لە هەرێمی کوردستان، پسپۆڕ لە کۆمەڵگەی نیشتەجێبوونی کوالیتی بەرز",
      quickLinks: "بەستەرە خێراکان",
      projects: "پڕۆژەکان",
      contact: "زانیاری پەیوەندی",
      rights: "هەموو مافێک پارێزراوە © 2026 دەروازەی گەرمیان"
    },
    // Project Detail Page
    projectDetail: {
      projectInfo: "زانیاری پڕۆژە",
      location: "شوێن",
      status: "دۆخ",
      units: "یەکەکان",
      type: "جۆر",
      ongoing: "بەردەوامە",
      completed: "تەواوکراوە",
      residential: "نیشتەجێبوون",
      interested: "خولیات هەیە؟ پەیوەندیمان پێوە بکە",
      aboutProject: "دەربارەی ئەم پڕۆژەیە",
      unitTypes: "جۆرەکانی یەکە",
      bedrooms: "ژووری نوستن",
      viewFloorPlan: "نەخشەی نهۆم ببینە",
      selectUnitType: "جۆری یەکە هەڵبژێرە",
      projectGallery: "گالەریی پڕۆژە",
      exterior: "دەرەوە",
      interior: "ناوەوە",
      amenities: "ئاسانکارییەکان",
      downloadBrochure: "داگرتنی بڕۆشور",
      typeLabel: "جۆر"
    },
    // Infrastructure Projects
    infrastructure: {
      sectionTitle: "پڕۆژەکانی ژێرخان",
      sectionSubtitle: "بنیاتنانی بنەمای پێشکەوتن",
      viewProject: "پڕۆژە ببینە",
      projectOverview: "گشتی پڕۆژە",
      projectTimeline: "کاتی پڕۆژە",
      keyObjectives: "ئامانجە سەرەکییەکان",
      designImplementation: "دیزاین و جێبەجێکردن",
      partnership: "هاوبەشی نێوان بەشی گشتی و تایبەت",
      communityImpact: "کاریگەری کۆمەڵایەتی",
      results: "ئەنجامەکان و دەستکەوتەکان",
      viewOnMap: "لە نەخشە ببینە",
      projectGallery: "گالەریی پڕۆژە",
      beforeAfter: "پێش و دوای"
    },
    // Social Projects
    social: {
      sectionTitle: "پڕۆژە کۆمەڵایەتییەکان",
      sectionSubtitle: "چاودێری کۆمەڵگەمان",
      viewProject: "پڕۆژە ببینە",
      projectOverview: "گشتی پڕۆژە",
      ourMission: "ئەرکمان",
      ourServices: "خزمەتگوزارییەکانمان",
      ourImpact: "کاریگەریمان",
      ourValues: "بەهاکانمان",
      completed: "تەواوبوو"
    }
  }
};

export const projectsData = [
  {
    id: "dli_shar",
    name: {
      en: "Dli Shar",
      ku: "دڵی شار"
    },
    type: "residential",
    category: ["residential", "apartments"],
    status: "ongoing",
    location: "Sulaymaniyah - Salim Street - Under Khosraw Khall Bridge",
    units: "1000+",
    description: {
      en: "A project in the heart of the city, designed with the most modern contemporary design by major engineering companies, making it very easy to decide to buy a unit in the project because of the outstanding services created in it.",
      ar: "مشروع في قلب المدينة، مصمم بأحدث التصاميم المعاصرة من قبل كبرى الشركات الهندسية، مما يجعل قرار شراء وحدة في المشروع سهلاً للغاية بفضل الخدمات المتميزة المتوفرة فيه.",
      ku: "پرۆژەیەک لە دڵی شاردا، بە نوێترین دیزاینی سەردەمیانە لەسەر دەستی گەورە کۆمپانیاکانی بواری ئەندازیاری نەخشێنراوە"
    },
    exteriorImages: [
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/jc6heq8d_3..jpeg",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/4c8t8cb1_7.jpeg",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/pajykgiz_24.jpeg",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/g1lrogo3_18.jpeg",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/2jx9pj4j_28.png",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/4jr9dhl3_14.jpeg",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/ov8tb5eb_25.jpeg",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/cuwesy5a_21.jpeg",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/lzzsh5fj_26.png",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/kec5cbzw_15.jpeg",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/b80rgvhv_22.jpeg",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/7ta2rz5t_23.jpeg",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/w1r4ghg3_11.jpeg",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/lgct7qto_29.png",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/80uo8xoo_4.jpeg"
    ],
    interiorImages: [
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/ob3say78_reception_Post.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/3vzjp2az_reception%202_Post.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/a9jfsiv2_13.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/i8bwie9u_14.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/uk4u8rq8_scene%201%20%20%281%29.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/oqr2kku6_scene%202%20%20copy.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/rhkb9agq_scene%202%20.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/42fqu0qc_scene%203%20%20copy.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/y7whewga_scene%204.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/1d15lpnw_scene%201%20.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/djwaa6n5_scene%202%20.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/w5k6994p_scene%203%20.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/pwfufqb1_scene%204.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/gti6r5bd_scene%205%20.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/8il1gong_scene%206.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/ot2yt53j_scene%207.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/ursy2y1n_dia%201.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/y9dnf6f9_dia%204.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/8d3fwcju_dia3.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/hbxusfkz_scene%201%20.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/9avnqwg2_scene%202%20.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/zgs26hh1_scene%203%20.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/cv77w7h2_final%20bed%201_Post.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/l6ediq1k_master%20bed%20_Post.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/n70dago7_master%20bedroom%20A%201_Post.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/ieffdvzb_master%20bedroom%20A%202_Post.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/2vadglme_master%20dressing_Post.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/8ykbhfq7_young%20bed%201_Post.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/380gyl6c_young%20bed%20dressing%20_Post.jpg"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/jc6heq8d_3..jpeg",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/4c8t8cb1_7.jpeg"
    ],
    logo: "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/s7c7uhsj_Screenshot%202026-02-08%20at%2013%2C16%2C20-Picsart-BackgroundRemover.png",
    amenities: ["Closed Car Park", "Clinic", "Gym", "Swimming Pool", "Market", "Knauf Ceiling", "Children's Garden", "Heating System", "Central Gas", "Turkish Bath", "Counter", "Internal Partition", "VRF System", "3 Entrance/Exit Gates"],
    unitTypes: [
      {
        id: "type_a",
        name: "Type A",
        area: "250 m²",
        bedrooms: 4,
        floorPlan: "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/keo7x9go_DS-250%20m2%20-Perspective-Plan.png",
        features: ["Master Bedroom 5.30 × 3.10 m", "Bedroom 1: 3.90 × 3.50 m", "Bedroom 2: 3.90 × 2.55 m", "Bedroom 3: 5.30 × 3.20 m", "Guest & Dining: 4.70 × 8.10 m", "Kitchen: 3.40 × 4.75 m"]
      },
      {
        id: "type_b",
        name: "Type B",
        area: "225 m²",
        bedrooms: 3,
        floorPlan: "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/ierht6l8_DS-225%20m2%20-Perspective-Plan.png",
        features: ["Master Bedroom", "2 Additional Bedrooms", "Living & Dining Area", "Modern Kitchen"]
      },
      {
        id: "type_c",
        name: "Type C",
        area: "200 m²",
        bedrooms: 3,
        floorPlan: "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/f7xil8g9_DS-200%20m2%20-Perspective-Plan.png",
        features: ["3 Bedrooms", "Spacious Living Room", "Contemporary Kitchen", "2 Bathrooms"]
      },
      {
        id: "type_d",
        name: "Type D",
        area: "160 m²",
        bedrooms: 2,
        floorPlan: "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/74o6e8l8_DS-160%20m2%20-Perspective-Plan.png",
        features: ["2 Bedrooms", "Open Plan Living", "Modern Kitchen", "Balcony"]
      }
    ]
  },
  {
    id: "bakrajo_hills",
    name: {
      en: "Bakrajo Hills",
      ku: "بەکرەجۆ هیڵس"
    },
    type: "residential",
    category: ["residential", "villas"],
    status: "ongoing",
    location: "Sulaymaniyah - 30m Bakrajo Road - Near Agricultural High School",
    units: "500+",
    description: {
      en: "Designed to offer the best of both modern living and natural beauty. Here your dreams become reality with carefully designed villas that promise comfort and vibrancy in every detail.",
      ar: "مصمم ليقدم ارقى مفاهيم الحياة العصرية والجمال الطبيعي. هنا تتحول أحلامك إلى واقع ملموس مع فيلات صممت بعناية فائقة تعدك بالراحة والحيوية في كل تفصيل.",
      ku: "دیزاین کراوە بۆ پێشکەشکردنی باشترینەکانی ھەردوو ژیانی مۆدێرن و جوانی سروشت"
    },
    exteriorImages: [
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/y2lczale_01-%20Bakrajo%20Hills%20-%20Type%20C%20-%20160%20sq.m%20%281%29.png",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/zyhx7pcl_02-%20Bakrajo%20Hills%20-%20Type%20C%20-%20160%20sq.m.png",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/97q4e4hf_03-%20Bakrajo%20Hills%20-%20Type%20C%20-%20160%20sq.m.png",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/feephxfa_01-%20Bakrajo%20Hills%20-%20Type%20B%20-%20203.5%20sq.m.png",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/eaznsk5h_02-%20Bakrajo%20Hills%20-%20Type%20B%20-%20203.5%20sq.m.png",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/vjnr1l41_03-%20Bakrajo%20Hills%20-%20Type%20B%20-%20203.5%20sq.m.png",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/wahumw1a_01-%20Bakrajo%20Hills%20-%20Type%20A%20-%20300%20sq.m.jpg",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/r64xvo7w_02-%20Bakrajo%20Hills%20-%20Type%20A%20-%20300%20sq.m.png"
    ],
    interiorImages: [
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/xw2i19om_1.png",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/u5iblr7a_3.png",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/j3oxu0er_4.png",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/ben81ivp_10.png",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/x1unf5nm_11.png",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/riteyelo_13.png",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/u3wducpp_15.png",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/dedvxic9_18.png",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/l72omdsa_20.png",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/697goxf3_22.png"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/y2lczale_01-%20Bakrajo%20Hills%20-%20Type%20C%20-%20160%20sq.m%20%281%29.png",
      "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/zyhx7pcl_02-%20Bakrajo%20Hills%20-%20Type%20C%20-%20160%20sq.m.png"
    ],
    logo: "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/n5302my5_Screenshot%202026-02-08%20at%2013%2C16%2C03-Picsart-BackgroundRemover.png",
    brochure: "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/dyld9jss_Bkarajo%20Brochure%20updated.pdf",
    amenities: ["Door-to-Door Service", "Car Service", "Gas Station", "Electric Car Charging", "Commercial Building", "Closed Children's Playground", "Large Water Tank", "4 Project Gates", "Sports Field", "Open Play Area", "Fountain", "Café & Restaurant", "Salon", "Barber Shop", "Bakery", "Library", "Horse Riding Area", "Mosque", "125,000 m² Greenery", "Health Center", "School", "Children's Garden", "Daycare", "Mall", "Supermarket", "Gym", "Swimming Pool"],
    unitTypes: [
      {
        id: "type_a",
        name: "Type A",
        area: "300 m²",
        bedrooms: 5,
        floors: 2,
        floorPlans: [
          { name: "Ground Floor", image: "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/cog1yyrm_Type%20A%20-%20Option%20002%20%281%29.jpg" },
          { name: "First Floor", image: "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/j955xmaj_Villa%20300%20sqm%20-%20First%20FF%20copy%281%29%20%281%29.jpg" }
        ],
        features: ["2 Floors", "2 Car Garage", "Private Garden", "Modern Kitchen", "Spacious Living Areas", "5 Bedrooms", "Multiple Bathrooms"]
      },
      {
        id: "type_b",
        name: "Type B",
        area: "203 m²",
        bedrooms: 4,
        floors: 2,
        floorPlans: [
          { name: "Ground Floor", image: "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/ogg1eov3_Ground%20Floor%20-%20Graphic%20Plan..png" },
          { name: "First Floor", image: "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/j2ibbxkf_First%20Floor%20-%20Graphic%20Plan.png" }
        ],
        features: ["2 Floors", "Private Garden", "Car Parking", "Modern Kitchen", "Spacious Living Areas", "Multiple Bedrooms", "Bathrooms"]
      },
      {
        id: "type_c",
        name: "Type C",
        area: "160 m²",
        bedrooms: 3,
        floors: 2,
        floorPlans: [
          { name: "Ground Floor", image: "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/3j7x5wit_Type%20C%20-%20Ground%20Floor%281%29%20%281%29.jpg" },
          { name: "First Floor", image: "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/wei9t9ui_Type%20C%20-%20First%20Floor%281%29.jpg" }
        ],
        features: ["2 Floors", "Private Garden", "Car Parking", "Modern Kitchen", "Spacious Living Areas", "Multiple Bedrooms", "Bathrooms"]
      }
    ]
  },
  {
    id: "dina_city",
    name: {
      en: "Dina City",
      ku: "دینا سیتی"
    },
    type: "residential",
    category: ["residential", "apartments"],
    status: "ongoing",
    location: "Sulaymaniyah - Kaziwa - Above Fajr Mosque",
    units: "800+",
    description: {
      en: "A home for an everlasting life. Choose Dina City to build a life full of opportunities. A complete place for a new beginning and a promising future.",
      ar: "منزل لحياة أبدية. اختر دينا سيتي لتبني حياة مليئة بالفرص. فهي المكان المتكامل لبداية جديدة ومستقبل واعد.",
      ku: "ماڵێک بۆ ژیانێکی هەمیشەی. دینا سیتی هەڵبژێرە بۆ بنیاتنانی ژیانێکی پڕ لە دەرفەت"
    },
    exteriorImages: [
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/rb5blul5_c1_Post_LightMix%20Interactive.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/xn9zl7pg_c2_Post_LightMix%20Interactive.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/3at8c977_c3_Postk.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/hw29qziq_c5_Post_LightMix%20Interactive.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/2a6n60wu_c7_Post_LightMix%20Interactive.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/de4uf8md_1.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/smim07sr_Type%20A%20Villas_V05_Scene.01.png",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/l916rfbk_Type%20A%20Villas_V05_Scene.02.png",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/lbaz9ho3_Type%20A%20Villas_V05_Scene.03.png",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/ymkfvf5q_Type%20A%20Villas_V05_Scene.04.png"
    ],
    interiorImages: [
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/ncbstf7y_dina%20interior%20%284%29.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/9w8iurv1_dina%20interior%20%286%29.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/goga2j0d_dina%20interior%20%288%29.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/rr7xajhh_dina%20interior%20%2810%29.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/flsiqk4q_dina%20interior%20%2811%29.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/xph6lhy5_dina%20interior%20%2812%29.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/efhsudfx_dina%20interior%20%2817%29.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/gpqx7vy0_dina%20interior%20%2821%29.jpg"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/rb5blul5_c1_Post_LightMix%20Interactive.jpg",
      "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/xn9zl7pg_c2_Post_LightMix%20Interactive.jpg"
    ],
    logo: "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/x7zrfv35_Screenshot%202026-02-08%20at%2013.15.43%201.png",
    brochure: "https://customer-assets.emergentagent.com/job_f5e23208-e2e1-478e-b660-88f2702726f3/artifacts/16bjto6i_Dina%20City%20Brochure.pdf",
    amenities: ["Closed Car Park", "Central Gas", "VRF System", "Turkish Bath", "Heating System", "Gym", "Swimming Pool", "Children's Garden", "Daycare", "Supermarket", "Private School", "Counter Set", "Knauf Ceiling"],
    unitTypes: [
      {
        id: "villa_a",
        name: "Type A",
        category: "villa",
        area: "250 m²",
        bedrooms: 3,
        floors: 2,
        floorPlans: [
          { name: "Ground Floor", image: "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/74qf8sgy_Ground%20Floor.png" },
          { name: "First Floor", image: "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/hlp6v0qw_First%20Floor.png" }
        ],
        features: ["Master Bedroom", "2 Additional Bedrooms", "Reception", "Kitchen", "Garden", "Car Parking", "Bathrooms"]
      },
      {
        id: "villa_b",
        name: "Type B",
        category: "villa",
        area: "220 m²",
        bedrooms: 3,
        floors: 2,
        floorPlans: [
          { name: "Ground Floor", image: "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/m1ppoajf_Ground%20Floor.png" },
          { name: "First Floor", image: "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/lqeon1xy_First%20Floor.png" }
        ],
        features: ["Master Bedroom", "2 Additional Bedrooms", "Reception", "Kitchen", "Garden", "Car Parking", "Bathrooms"]
      },
      {
        id: "apt_a",
        name: "Type A",
        category: "apartment",
        area: "200 m²",
        bedrooms: 3,
        floorPlan: "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/rtcr5knr_dina%20interior%20%281%29.jpg",
        features: ["Master Bedroom with En-Suite", "2 Additional Bedrooms", "Open-Plan Living & Dining Area", "Modern Kitchen with Island", "Dressing Room", "2 Bathrooms", "Double Balcony"]
      },
      {
        id: "apt_b",
        name: "Type B",
        category: "apartment",
        area: "160 m²",
        bedrooms: 3,
        floorPlan: "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/toaz7gxb_dina%20interior%20%2819%29.jpg",
        features: ["Master Bedroom with En-Suite", "2 Additional Bedrooms", "Living Room with Seating Area", "Dining Area", "Kitchen", "Bathroom", "Balcony"]
      }
    ]
  },
  {
    id: "nawzhen_city",
    name: {
      en: "Nawzhen City",
      ku: "نەوژین سیتی",
      ar: "مدينة نوژين"
    },
    type: "residential",
    category: ["residential", "villas"],
    status: "completed",
    location: "Kalar - Garmian Region",
    units: "500+",
    description: {
      en: "Nawzhen City represents a new standard of modern living in the heart of Garmian. This prestigious residential community features elegantly designed villas with distinctive brick-red roofing, spacious layouts, and beautiful landscaping. With its central playground, tree-lined streets, and family-friendly environment, Nawzhen City offers the perfect blend of comfort, style, and community living.",
      ku: "نەوژین سیتی پێوەرێکی نوێ بۆ ژیانی مۆدێرن لە دڵی گەرمیان نوێنەرایەتی دەکات. ئەم کۆمەڵگەی نیشتەجێبوونە پڕە لە جوانی سروشت و ڤێلا بە دیزانی جوان و سەردەمیانە بە بەکارهێنانی سەقفی قرمیتی بۆ ڤێلاکان و دیمەنێکی جوانی بەخشیوە بە پڕۆژەکە. بە یاریگەی ناوەندی و شەقامە سەوزەکان و ژینگەیەکی گونجاو بۆ خێزان، نەوژین سیتی تێکەڵەی تەواوی ئاسوودەیی و شێواز و ژیانی کۆمەڵایەتی پێشکەش دەکات.",
      ar: "تمثل \"مدينة نوژين\" معيارًا جديدًا للحياة العصرية في قلب \"گرميان\". يتميز هذا المجتمع السكني المرموق بفيلات صممت بأناقة تزدان بأسقف القرميد الأحمر المميز، وتقسيمات واسعة تحتضنها المناظر الطبيعية الخلابة. مع ملعب مركزي وشوارع تصطف على جانبيها الأشجار. تقدم \"مدينة نوژین\" المزيج المثالي بين الراحة والأناقة، والحياة المجتمعية الآمنة."
    },
    exteriorImages: [
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/2vbctr82_Screenshot%202026-02-15%20at%2011.39.32.png",
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/2er4ke73_Screenshot%202026-02-15%20at%2011.41.36.png",
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/hzr7dinm_Screenshot%202026-02-15%20at%2011.41.59.png",
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/cen50xwu_Screenshot%202026-02-15%20at%2011.42.21.png",
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/yii7seu5_Screenshot%202026-02-15%20at%2011.43.10.png"
    ],
    interiorImages: [],
    images: [
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/2vbctr82_Screenshot%202026-02-15%20at%2011.39.32.png",
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/2er4ke73_Screenshot%202026-02-15%20at%2011.41.36.png",
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/hzr7dinm_Screenshot%202026-02-15%20at%2011.41.59.png",
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/cen50xwu_Screenshot%202026-02-15%20at%2011.42.21.png",
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/yii7seu5_Screenshot%202026-02-15%20at%2011.43.10.png"
    ],
    logo: "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/fjm800hc_Screenshot%202026-02-14%20no%20background%20at%2015.00.20%20copy.png",
    hideInteriorGallery: true,
    hideLargeGallery: true,
    amenities: ["Central Playground", "Tree-Lined Streets", "Green Spaces", "Paved Roads", "Security", "Community Center", "Modern Infrastructure", "Family-Friendly Environment", "Landscaped Gardens", "Street Lighting"],
    unitTypes: []
  },
  {
    id: "dream_land",
    name: {
      en: "Dream Land",
      ku: "دریم لاند",
      ar: "دريم لاند"
    },
    type: "residential",
    category: ["residential", "apartments", "villas"],
    status: "completed",
    location: "Sulaymaniyah & Kalar",
    units: "1500+",
    description: {
      en: "Dream Land is an extraordinary mixed-use development spanning three prestigious phases across Kurdistan. Dream Land 1 in Sulaymaniyah and Dream Land 2 in Kalar feature stunning apartment towers with modern amenities, while Dream Land 3 in Kalar offers exclusive waterfront villas with private gardens. This visionary project includes iconic twin towers, a stunning marina, butterfly garden, yacht club, and premium retail destinations—creating an unparalleled lifestyle experience.",
      ku: "دریم لاند پڕۆژەیەکی گەورە و تایبەتە کە لە سێ قۆناغدا پێکهاتووە. دریم لاند ١ لە سلێمانی و دریم لاند ٢ لە کەلار شووقەی مۆدێرن بە هەموو خزمەتگوزارییەکانەوە پێشکەش دەکەن. دریم لاند ٣ لە کەلار ڤیلای لوکس لە کەناری دەریاچە بە باخچەی تایبەت دابین دەکات. ئەم پڕۆژەیە بەندەر و باخچەی پەروانە و یاخت کلوب و ناوەندی بازاڕی لوکس لەخۆدەگرێت.",
      ar: "ثلاث مراحل مرموقة في إقليم كردستان. يضم دريم لاند 1 في السليمانية ودريم لاند 2 في كلار أبراج شقق مميزة تتمتع بتصاميم عصرية ووسائل راحة حديثة، فيما يقدم دريم لاند 3 في كلار فيلات حصرية مطلة على الواجهة المائية، مع حدائق خاصة تمنح السكان أسلوب حياة راقياً ومتكاملاً. ويشمل هذا المشروع الطموح برجين أيقونيين، ومرسى خلاباً، وحديقة فراشات، ونادي يخوت، إضافةً إلى وجهات تسوق فاخرة، ليشكل وجهة متكاملة تجمع بين السكن والترفيه والاستثمار"
    },
    exteriorImages: [
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/109ll880_Screenshot%202026-02-17%20at%2009.52.27.png",
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/loo1owjm_Screenshot%202026-02-17%20at%2009.52.46.png",
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/dkruhq5d_Screenshot%202026-02-17%20at%2009.53.28.png",
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/hav0fgyr_Screenshot%202026-02-17%20at%2009.54.55.png",
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/dagc5zlu_Screenshot%202026-02-17%20at%2009.55.15.png",
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/wmng4bsi_Screenshot%202026-02-17%20at%2009.55.30.png"
    ],
    interiorImages: [],
    images: [
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/109ll880_Screenshot%202026-02-17%20at%2009.52.27.png",
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/loo1owjm_Screenshot%202026-02-17%20at%2009.52.46.png",
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/dkruhq5d_Screenshot%202026-02-17%20at%2009.53.28.png",
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/hav0fgyr_Screenshot%202026-02-17%20at%2009.54.55.png",
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/dagc5zlu_Screenshot%202026-02-17%20at%2009.55.15.png",
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/wmng4bsi_Screenshot%202026-02-17%20at%2009.55.30.png"
    ],
    logo: "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/qfeicaxw_Screenshot%202026-02-17%20at%2009.57.04%20copy.png",
    hideInteriorGallery: true,
    hideLargeGallery: true,
    amenities: ["Twin Towers", "Waterfront Marina", "Yacht Club", "Butterfly Garden", "Premium Retail", "Villas with Private Gardens", "Swimming Pool", "Fitness Center", "24/7 Security", "Underground Parking", "Landscaped Promenades", "Children's Play Areas", "Cafés & Restaurants", "Green Spaces", "Modern Infrastructure"],
    unitTypes: []
  }
];

export const heroSlides = [
  {
    image: "https://images.unsplash.com/photo-1519662978799-2f05096d3636?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzY4NjMyMDUyfDA&ixlib=rb-4.1.0&q=85",
    title: {
      en: "Premium Residential Communities",
      ar: "مجتمعات سكنية متميزة",
      ku: "کۆمەڵگەی نیشتەجێبوونی تایبەت"
    },
    subtitle: {
      en: "Building the future of Kurdistan",
      ar: "بناء مستقبل كردستان",
      ku: "داهاتووی کوردستان بنیاد دەنێین"
    }
  },
  {
    image: "https://images.unsplash.com/photo-1574848296471-28f79a036f79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzY4NjMyMDUyfDA&ixlib=rb-4.1.0&q=85",
    title: {
      en: "Excellence in Construction",
      ar: "التميز في البناء",
      ku: "باشی لە بیناسازی"
    },
    subtitle: {
      en: "Quality you can trust",
      ar: "جودة يمكنك الثقة بها",
      ku: "کوالیتی کە متمانەی پێ دەکەیت"
    }
  },
  {
    image: "https://images.unsplash.com/photo-1580041065738-e72023775cdc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhcGFydG1lbnR8ZW58MHx8fHwxNzY4Njc5OTkzfDA&ixlib=rb-4.1.0&q=85",
    title: {
      en: "Luxury Living Spaces",
      ar: "مساحات سكنية فاخرة",
      ku: "شوێنی ژیانی شاهانە"
    },
    subtitle: {
      en: "Where comfort meets elegance",
      ar: "حيث تلتقي الراحة بالأناقة",
      ku: "کە ئاسوودەیی لەگەڵ جوانی دەگونجێت"
    }
  }
];

export const jobListings = [
  {
    id: 1,
    title: {
      en: "Civil Engineer",
      ar: "مهندس مدني",
      ku: "ئەندازیاری مەدەنی"
    },
    category: "engineering",
    location: {
      en: "Sulaymaniyah",
      ar: "السليمانية",
      ku: "سلێمانی"
    },
    type: {
      en: "Full-time",
      ar: "دوام كامل",
      ku: "کاری تەواو"
    },
    description: {
      en: "Experienced civil engineer for residential construction projects",
      ar: "مهندس مدني ذو خبرة لمشاريع البناء السكني",
      ku: "ئەندازیاری مەدەنی شارەزا بۆ پڕۆژەکانی بیناسازی نیشتەجێبوون"
    }
  },
  {
    id: 2,
    title: {
      en: "Project Manager",
      ar: "مدير مشروع",
      ku: "بەڕێوەبەری پڕۆژە"
    },
    category: "management",
    location: {
      en: "Sulaymaniyah",
      ar: "السليمانية",
      ku: "سلێمانی"
    },
    type: {
      en: "Full-time",
      ar: "دوام كامل",
      ku: "کاری تەواو"
    },
    description: {
      en: "Manage multiple residential development projects",
      ar: "إدارة مشاريع تطوير سكنية متعددة",
      ku: "بەڕێوەبردنی چەند پڕۆژەیەکی گەشەپێدانی نیشتەجێبوون"
    }
  },
  {
    id: 3,
    title: {
      en: "Sales Executive",
      ar: "مسؤول مبيعات",
      ku: "بەرپرسی فرۆشتن"
    },
    category: "sales",
    location: {
      en: "Multiple Locations",
      ar: "مواقع متعددة",
      ku: "چەند شوێنێک"
    },
    type: {
      en: "Full-time",
      ar: "دوام كامل",
      ku: "کاری تەواو"
    },
    description: {
      en: "Drive sales for luxury residential properties",
      ar: "قيادة مبيعات العقارات السكنية الفاخرة",
      ku: "فرۆشتنی خانووی نیشتەجێبوونی شاهانە"
    }
  },
  {
    id: 4,
    title: {
      en: "Architect",
      ar: "مهندس معماري",
      ku: "ئەندازیار"
    },
    category: "engineering",
    location: {
      en: "Sulaymaniyah",
      ar: "السليمانية",
      ku: "سلێمانی"
    },
    type: {
      en: "Full-time",
      ar: "دوام كامل",
      ku: "کاری تەواو"
    },
    description: {
      en: "Design innovative residential communities",
      ar: "تصميم مجتمعات سكنية مبتكرة",
      ku: "دیزاینکردنی کۆمەڵگەی نیشتەجێبوونی داهێنەرانە"
    }
  }
];

export const galleryImages = [
  {
    url: "https://images.unsplash.com/photo-1689574666546-75e1036e55fb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxyZXNpZGVudGlhbCUyMGNvbW11bml0eSUyMGNvbnN0cnVjdGlvbnxlbnwwfHx8fDE3Njg2ODAwMjF8MA&ixlib=rb-4.1.0&q=85",
    category: {
      en: "Construction",
      ar: "البناء",
      ku: "بیناسازی"
    }
  },
  {
    url: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB2aWxsYXxlbnwwfHx8fDE3Njg2MzI0MDN8MA&ixlib=rb-4.1.0&q=85",
    category: {
      en: "Villa",
      ar: "فيلا",
      ku: "ڤێلا"
    }
  },
  {
    url: "https://images.unsplash.com/photo-1613977257365-aaae5a9817ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjB2aWxsYXxlbnwwfHx8fDE3Njg2MzI0MDN8MA&ixlib=rb-4.1.0&q=85",
    category: {
      en: "Villa",
      ar: "فيلا",
      ku: "ڤێلا"
    }
  },
  {
    url: "https://images.unsplash.com/photo-1763783695583-c0703902d318?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxyZXNpZGVudGlhbCUyMGNvbW11bml0eSUyMGNvbnN0cnVjdGlvbnxlbnwwfHx8fDE3Njg2ODAwMjF8MA&ixlib=rb-4.1.0&q=85",
    category: {
      en: "Community",
      ar: "مجتمع",
      ku: "کۆمەڵگە"
    }
  },
  {
    url: "https://customer-assets.emergentagent.com/job_37c30a3a-473e-4636-8923-f847e72da520/artifacts/ln64fzd4_c3_Postk.jpg",
    category: {
      en: "Interior",
      ar: "داخلي",
      ku: "ناوەوە"
    }
  }
];

export const companyInfo = {
  phone: ["0770 197 0606", "0750 197 0606", "0770 500 3434", "0750 500 3434"],
  email: "info@darwazay-garmyan.com",
  address: {
    en: "Sulaymaniyah - Salim Street - Under Khosraw Khall Bridge - Near Rêkxistin 1 Roundabout",
    ku: "سلێمانی - شەقامی سالم - خوار پردی خەسرەو خاڵ - نزیک مەڵبەندی یەکی ڕێکخستن"
  },
  social: {
    instagram: "https://www.instagram.com/darwazay_garmyan",
    facebook: "https://www.facebook.com/p/Darwazay-Garmyan-61568814324672/"
  },
  mapCoordinates: {
    lat: 35.5558,
    lng: 45.4329
  }
};

// Infrastructure Projects Data
export const infrastructureProjectsData = [
  {
    id: "bakhtiyari_intersection",
    name: {
      en: "The Bakhtiyari Intersection",
      ar: "تقاطع بختياري",
      ku: "چوارڕێی بەختیاری"
    },
    type: "road_construction",
    category: "infrastructure",
    status: "completed",
    location: {
      en: "Bakhtiari Park Gateway, Sulaymaniyah",
      ar: "مدخل حديقة بختياري، السليمانية",
      ku: "دەروازەی پارکی بەختیاری، سلێمانی"
    },
    mapUrl: "https://maps.app.goo.gl/5Jw2ZHmMwUssobmR9",
    heroImage: "https://customer-assets.emergentagent.com/job_f0a38915-5596-4a0c-9b31-9c6ee3630322/artifacts/ilqvdzl5_Screenshot%202026-02-12%20at%2010.47.20.png",
    images: [
      "https://customer-assets.emergentagent.com/job_f0a38915-5596-4a0c-9b31-9c6ee3630322/artifacts/3kfpo0cq_Screenshot%202026-02-12%20at%2011.21.17.png",
      "https://customer-assets.emergentagent.com/job_f0a38915-5596-4a0c-9b31-9c6ee3630322/artifacts/b3ogo1p6_Screenshot%202026-02-12%20at%2011.21.35.png",
      "https://customer-assets.emergentagent.com/job_f0a38915-5596-4a0c-9b31-9c6ee3630322/artifacts/dyyit1jk_Screenshot%202026-02-12%20at%2011.21.57.png",
      "https://customer-assets.emergentagent.com/job_f0a38915-5596-4a0c-9b31-9c6ee3630322/artifacts/ilqvdzl5_Screenshot%202026-02-12%20at%2010.47.20.png",
      "https://customer-assets.emergentagent.com/job_f0a38915-5596-4a0c-9b31-9c6ee3630322/artifacts/rpoahphe_Screenshot%202026-02-12%20at%2010.47.44.png",
      "https://customer-assets.emergentagent.com/job_f0a38915-5596-4a0c-9b31-9c6ee3630322/artifacts/714z6bir_Screenshot%202026-02-12%20at%2010.49.05.png"
    ],
    videos: ["https://ik.imagekit.io/vdrhxyigu/0212.mp4"],
    overview: {
      en: "The intersection project located in front of Bakhtiari Park represents a strategic infrastructure upgrade designed to address long-standing traffic congestion at one of Sulaymaniyah's most critical city entry points. This area serves as a primary gateway for daily commuters, visitors, and commercial traffic, making efficient traffic flow essential for both economic activity and quality of life.",
      ar: "يمثل مشروع التقاطع الواقع أمام حديقة بختياري ترقية استراتيجية للبنية التحتية صُممت لمعالجة الازدحام المروري المزمن عند إحدى أهم نقاط الدخول إلى مدينة السليمانية. تعمل هذه المنطقة كبوابة رئيسية للمسافرين يومياً والزوار وحركة المرور التجارية، مما يجعل كفاءة تدفق المرور ضرورية للنشاط الاقتصادي وجودة الحياة.",
      ku: "پڕۆژەی چوارڕێ کە لە بەرامبەر پارکی بەختیاری دایە، نوێکردنەوەیەکی ستراتیژی ژێرخانە کە بۆ چارەسەرکردنی قەرەباڵغی هاتووچۆ لە یەکێک لە گرنگترین دەروازەکانی ناو شاری سلێمانی دیزاین کراوە. ئەم ناوچەیە وەک دەروازەیەکی سەرەکی کاردەکات بۆ ئەو کەسانەی کە ڕۆژانە هاتووچۆ دەکەن و میوانان و هاتووچۆی بازرگانی."
    },
    challenge: {
      en: "Prior to the project, the junction experienced frequent bottlenecks, irregular vehicle movement, and safety concerns for both drivers and pedestrians, especially during peak hours.",
      ar: "قبل المشروع، كان التقاطع يعاني من اختناقات متكررة وحركة مركبات غير منتظمة ومخاوف تتعلق بالسلامة للسائقين والمشاة، خاصة خلال ساعات الذروة.",
      ku: "پێش پڕۆژەکە، چوارڕێکە بەردەوام تووشی قەرەباڵغی دەبوو، هاتووچۆی ئۆتۆمبێل نارێک بوو، و نیگەرانی سەبارەت بە سەلامەتی شۆفێران و پیادەڕەوان، بەتایبەتی لە کاتی قەرەباڵغیدا."
    },
    objectives: {
      en: [
        "Reduce congestion at a major entrance to the city",
        "Improve traffic efficiency by optimizing lane distribution and turning movements",
        "Enhance road safety for vehicles and pedestrians",
        "Support urban growth by strengthening connectivity between residential, recreational, and commercial zones",
        "Create a visually organized gateway that reflects modern city planning standards"
      ],
      ar: [
        "تقليل الازدحام عند مدخل رئيسي للمدينة",
        "تحسين كفاءة المرور من خلال تحسين توزيع المسارات وحركات الانعطاف",
        "تعزيز السلامة المرورية للمركبات والمشاة",
        "دعم النمو الحضري من خلال تعزيز الاتصال بين المناطق السكنية والترفيهية والتجارية",
        "إنشاء بوابة منظمة بصرياً تعكس معايير التخطيط الحضري الحديث"
      ],
      ku: [
        "کەمکردنەوەی قەرەباڵغی لە دەروازەیەکی سەرەکی شار",
        "باشترکردنی کارایی هاتووچۆ بە ڕێکخستنی دابەشکردنی لاین و جوڵەی سووڕانەوە",
        "بەرزکردنەوەی سەلامەتی ڕێگا بۆ ئۆتۆمبێل و پیادەڕەوان",
        "پشتیوانی گەشەی شارەوانی بە بەهێزکردنی پەیوەندی نێوان ناوچە نیشتەجێبوون و ڕامیاری و بازرگانییەکان",
        "دروستکردنی دەروازەیەکی ڕێکخراو بە شێوەیەکی بینراو کە پێوەرەکانی پلاندانانی شاری مۆدێرن دەردەخات"
      ]
    },
    implementation: {
      en: "The project involved comprehensive traffic studies, geometric redesign of the intersection, upgraded road surfaces, improved signage, and clearer lane markings. Special attention was given to pedestrian accessibility around Bakhtiari Park, ensuring safer crossings and smoother movement between public spaces and surrounding roads. From a planning perspective, the intersection was engineered to handle increasing traffic volumes while maintaining flexibility for future expansion. The layout promotes continuous flow, minimizes conflict points, and significantly reduces waiting times compared to the previous configuration.",
      ar: "تضمن المشروع دراسات مرورية شاملة، وإعادة تصميم هندسي للتقاطع، وترقية أسطح الطرق، وتحسين اللافتات، وعلامات مسارات أوضح. تم إيلاء اهتمام خاص لإمكانية وصول المشاة حول حديقة بختياري، مما يضمن عبوراً أكثر أماناً وحركة أكثر سلاسة بين الأماكن العامة والطرق المحيطة. من منظور التخطيط، تم تصميم التقاطع للتعامل مع أحجام المرور المتزايدة مع الحفاظ على المرونة للتوسع المستقبلي.",
      ku: "پڕۆژەکە توێژینەوەی هاتووچۆی گشتگیر، دیزاینکردنەوەی جیۆمەتری چوارڕێکە، نوێکردنەوەی ڕووکاری ڕێگاکان، باشترکردنی نیشانەکان، و نیشانەکردنی لاینی ڕوونتر لەخۆ دەگرت. سەرنجی تایبەت درا بە دەسکەوتن بە پیادەڕەوان لە دەوری پارکی بەختیاری، دڵنیابوون لە پەڕینەوەی سەلامەتر و جوڵەی نەرمتر لە نێوان شوێنە گشتییەکان و ڕێگاکانی دەوروبەر."
    },
    partnership: {
      en: "One of the most remarkable aspects of this project is its successful execution through collaboration between government authorities and the private sector. This partnership model allowed technical expertise, funding, and project management capabilities to align toward a shared goal: delivering tangible improvements for the community. This cooperative approach not only accelerated project completion but also ensured high construction standards and long-term sustainability.",
      ar: "أحد أبرز جوانب هذا المشروع هو تنفيذه الناجح من خلال التعاون بين السلطات الحكومية والقطاع الخاص. سمح نموذج الشراكة هذا بمحاذاة الخبرة الفنية والتمويل وقدرات إدارة المشاريع نحو هدف مشترك: تقديم تحسينات ملموسة للمجتمع. لم يسرع هذا النهج التعاوني من إنجاز المشروع فحسب، بل ضمن أيضاً معايير بناء عالية واستدامة طويلة المدى.",
      ku: "یەکێک لە لایەنە جوانترەکانی ئەم پڕۆژەیە جێبەجێکردنی سەرکەوتووی بەهۆی هاوکاری نێوان دەسەڵاتەکانی حکومەت و بەشی تایبەتەوە. ئەم شێوازی هاوبەشییە ڕێگەی دا شارەزایی تەکنیکی و دارایی و توانای بەڕێوەبردنی پڕۆژە یەکبگرن بەرەو ئامانجێکی هاوبەش: گەیاندنی باشترکردنی ڕاستەقینە بۆ کۆمەڵگە."
    },
    results: {
      en: [
        "Noticeably reduced traffic congestion at peak hours",
        "Improved access to Bakhtiari Park and nearby neighborhoods",
        "Increased road safety and driving comfort",
        "Enhanced the overall image of Sulaymaniyah's urban entrance"
      ],
      ar: [
        "تقليل ملحوظ للازدحام المروري في ساعات الذروة",
        "تحسين الوصول إلى حديقة بختياري والأحياء المجاورة",
        "زيادة السلامة المرورية وراحة القيادة",
        "تحسين الصورة العامة لمدخل مدينة السليمانية"
      ],
      ku: [
        "کەمکردنەوەی بەرچاو لە قەرەباڵغی هاتووچۆ لە کاتی قەرەباڵغیدا",
        "باشترکردنی دەسکەوتن بە پارکی بەختیاری و گەڕەکەکانی نزیک",
        "زیادکردنی سەلامەتی ڕێگا و ئاسوودەیی لەسەریخوردن",
        "باشترکردنی وێنەی گشتی دەروازەی شارەوانی سلێمانی"
      ]
    },
    conclusion: {
      en: "The project now stands as a practical example of how targeted infrastructure investments can directly improve daily life while supporting broader city development goals.",
      ar: "يقف المشروع الآن كمثال عملي على كيف يمكن لاستثمارات البنية التحتية المستهدفة أن تحسن الحياة اليومية مباشرة مع دعم أهداف تطوير المدينة الأوسع.",
      ku: "پڕۆژەکە ئێستا وەک نموونەیەکی کردەیی بەرز دەبێت کە چۆن وەبەرهێنانی ژێرخان بەشێوەیەکی ڕاستەوخۆ دەتوانێت ژیانی ڕۆژانە باشتر بکات لەکاتێکدا پشتیوانی ئامانجە فراوانترەکانی گەشەپێدانی شار دەکات."
    },
    timeline: [
      {
        phase: { en: "Planning & Studies", ar: "التخطيط والدراسات", ku: "پلاندانان و توێژینەوە" },
        description: { en: "Comprehensive traffic studies and geometric redesign planning", ar: "دراسات مرورية شاملة وتخطيط إعادة التصميم الهندسي", ku: "توێژینەوەی هاتووچۆی گشتگیر و پلاندانانی دیزاینکردنەوەی جیۆمەتری" }
      },
      {
        phase: { en: "Partnership Formation", ar: "تشكيل الشراكة", ku: "پێکهێنانی هاوبەشی" },
        description: { en: "Collaboration agreement between government and private sector", ar: "اتفاقية تعاون بين الحكومة والقطاع الخاص", ku: "ڕێکەوتنی هاوکاری نێوان حکومەت و بەشی تایبەت" }
      },
      {
        phase: { en: "Construction Phase", ar: "مرحلة البناء", ku: "قۆناغی بیناسازی" },
        description: { en: "Road surface upgrades, signage installation, and lane marking", ar: "ترقية أسطح الطرق وتركيب اللافتات ووضع علامات المسارات", ku: "نوێکردنەوەی ڕووکاری ڕێگا، دانانی نیشانە، و نیشانەکردنی لاین" }
      },
      {
        phase: { en: "Project Completion", ar: "اكتمال المشروع", ku: "تەواوبوونی پڕۆژە" },
        description: { en: "Final inspections and official opening to public traffic", ar: "التفتيشات النهائية والافتتاح الرسمي لحركة المرور العامة", ku: "پشکنینی کۆتایی و کردنەوەی فەرمی بۆ هاتووچۆی گشتی" }
      }
    ]
  }
];

// Social Projects Data
export const socialProjectsData = [
  {
    id: "haji_ahoo_elderly_home",
    name: {
      en: "Home for the Elderly by Haji Ahoo",
      ar: "دار المسنين من حاجي آهو",
      ku: "ماڵی بەساڵاچووان لەلایەن حاجی ئاهو"
    },
    type: "social_care",
    category: "social",
    status: "completed",
    location: {
      en: "Garmian Region, Kurdistan",
      ar: "منطقة گرميان، كردستان",
      ku: "ناوچەی گەرمیان، کوردستان"
    },
    heroImage: "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/ybsvc3ft_434176773_820199503469871_5890447649251683886_n.jpg",
    logo: "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/ybsvc3ft_434176773_820199503469871_5890447649251683886_n.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_bakhtiyari-dev/artifacts/ybsvc3ft_434176773_820199503469871_5890447649251683886_n.jpg"
    ],
    overview: {
      en: "The Home for the Elderly by Haji Ahoo stands as a testament to Darwazay Garmyan's commitment to social responsibility and community care. This charitable project provides a dignified, comfortable, and loving home for elderly citizens who require assistance and support in their golden years. The facility represents a pioneering initiative in the Garmian region, addressing a critical social need while honoring Kurdish traditions of respecting and caring for elders.",
      ar: "يقف دار المسنين من حاجي آهو شاهداً على التزام درواز كرميان بالمسؤولية الاجتماعية ورعاية المجتمع. يوفر هذا المشروع الخيري منزلاً كريماً ومريحاً ومحباً للمواطنين المسنين الذين يحتاجون إلى المساعدة والدعم في سنواتهم الذهبية. تمثل المنشأة مبادرة رائدة في منطقة كرميان، تعالج حاجة اجتماعية حرجة مع تكريم التقاليد الكردية في احترام ورعاية كبار السن.",
      ku: "ماڵی بەساڵاچووان لەلایەن حاجی ئاهو وەک بەڵگەیەک دەوەستێت بۆ پابەندبوونی دەروازەی گەرمیان بە بەرپرسیارێتی کۆمەڵایەتی و چاودێری کۆمەڵگە. ئەم پڕۆژە خێرخوازییە ماڵێکی شایستە و ئارام و خۆشەویستانە بۆ هاوڵاتیانی بەساڵاچوو دابین دەکات کە پێویستیان بە یارمەتی و پشتیوانییە لە ساڵانی زێڕینیاندا. ئەم دامەزراوەیە دەستپێشخەرییەکی پێشەنگ لە ناوچەی گەرمیان نوێنەرایەتی دەکات، پێداویستییەکی کۆمەڵایەتی گرنگ چارەسەر دەکات لە هەمان کاتدا ڕێز لە نەریتە کوردییەکان دەگرێت بۆ ڕێزگرتن و چاودێریکردنی بەساڵاچووان."
    },
    mission: {
      en: "Our mission is to provide exceptional care and support for elderly individuals who can no longer live independently, ensuring they spend their remaining years in comfort, dignity, and with the companionship they deserve. We believe every elder deserves to be treated with respect, love, and the highest standard of care.",
      ar: "مهمتنا هي تقديم رعاية ودعم استثنائيين للأفراد المسنين الذين لم يعودوا قادرين على العيش بشكل مستقل، مع ضمان قضاء سنواتهم المتبقية في راحة وكرامة ومع الرفقة التي يستحقونها. نؤمن أن كل مسن يستحق أن يُعامل باحترام ومحبة وأعلى معايير الرعاية.",
      ku: "ئەرکمان ئەوەیە چاودێری و پشتیوانی نایاب بۆ کەسانی بەساڵاچوو دابین بکەین کە چیتر ناتوانن بە سەربەخۆیی بژین، دڵنیابوون لەوەی ساڵانی ماوەیان بە ئارامی و شایستەیی و لەگەڵ هاوبەشی شایستەیان بەسەر دەبەن. باوەڕمان وایە هەموو بەساڵاچوویەک شایستەی ئەوەیە بە ڕێز و خۆشەویستی و بەرزترین پێوەری چاودێری مامەڵەی لەگەڵ بکرێت."
    },
    services: {
      en: [
        "24/7 professional nursing care and medical supervision",
        "Comfortable private and semi-private accommodations",
        "Nutritious meals prepared according to dietary needs",
        "Regular health check-ups and medication management",
        "Recreational activities and social engagement programs",
        "Physical therapy and rehabilitation services",
        "Spiritual and emotional support",
        "Clean and safe living environment"
      ],
      ar: [
        "رعاية تمريضية مهنية وإشراف طبي على مدار الساعة",
        "أماكن إقامة خاصة وشبه خاصة مريحة",
        "وجبات مغذية معدة وفقاً للاحتياجات الغذائية",
        "فحوصات صحية منتظمة وإدارة الأدوية",
        "أنشطة ترفيهية وبرامج مشاركة اجتماعية",
        "خدمات العلاج الطبيعي وإعادة التأهيل",
        "الدعم الروحي والعاطفي",
        "بيئة معيشية نظيفة وآمنة"
      ],
      ku: [
        "چاودێری پەرستاری پیشەیی و چاودێری پزیشکی ٢٤/٧",
        "شوێنی نیشتەجێبوونی تایبەت و ئارام",
        "خواردنی بەخێر ئامادەکراو بەپێی پێداویستی خۆراکی",
        "پشکنینی تەندروستی ماوەیی و بەڕێوەبردنی دەرمان",
        "چالاکییەکانی ڕامیاری و بەرنامەی بەشداریکردنی کۆمەڵایەتی",
        "خزمەتگوزاری فیزیۆتیراپی و نوێکردنەوە",
        "پشتیوانی ڕۆحی و هەستی",
        "ژینگەی ژیانی پاک و سەلامەت"
      ]
    },
    impact: {
      en: [
        "Provided dignified care for dozens of elderly residents",
        "Created employment opportunities for local healthcare workers",
        "Established a model for elderly care in the Kurdistan Region",
        "Strengthened community bonds through volunteer programs",
        "Raised awareness about the importance of elderly care"
      ],
      ar: [
        "قدمت رعاية كريمة لعشرات من كبار السن المقيمين",
        "خلقت فرص عمل للعاملين المحليين في مجال الرعاية الصحية",
        "أسست نموذجاً لرعاية المسنين في إقليم كردستان",
        "عززت الروابط المجتمعية من خلال برامج التطوع",
        "رفعت الوعي حول أهمية رعاية المسنين"
      ],
      ku: [
        "چاودێری شایستە بۆ دەیان دانیشتووی بەساڵاچوو دابین کرا",
        "دەرفەتی کار بۆ کرێکارانی چاودێری تەندروستی ناوخۆیی دروست کرا",
        "مۆدێلێک بۆ چاودێری بەساڵاچووان لە هەرێمی کوردستان دامەزرا",
        "پەیوەندییەکانی کۆمەڵگە بەهێز کرا لە ڕێگەی بەرنامەکانی خۆبەخشەوە",
        "هۆشیاری سەبارەت بە گرنگی چاودێری بەساڵاچووان بەرز کرایەوە"
      ]
    },
    values: {
      en: [
        { title: "Compassion", description: "Treating every resident with kindness, empathy, and understanding" },
        { title: "Dignity", description: "Preserving the self-worth and independence of our elderly residents" },
        { title: "Excellence", description: "Maintaining the highest standards of care and service" },
        { title: "Community", description: "Building a warm, family-like environment for all residents" }
      ],
      ar: [
        { title: "الرحمة", description: "معاملة كل مقيم بلطف وتعاطف وتفهم" },
        { title: "الكرامة", description: "الحفاظ على تقدير الذات واستقلالية كبار السن المقيمين لدينا" },
        { title: "التميز", description: "الحفاظ على أعلى معايير الرعاية والخدمة" },
        { title: "المجتمع", description: "بناء بيئة دافئة تشبه الأسرة لجميع المقيمين" }
      ],
      ku: [
        { title: "دڵسۆزی", description: "مامەڵەکردن لەگەڵ هەموو دانیشتوویەک بە میهرەبانی و هەستپێکردن و تێگەیشتن" },
        { title: "شایستەیی", description: "پاراستنی شکۆ و سەربەخۆیی دانیشتووانی بەساڵاچوومان" },
        { title: "نایابی", description: "پاراستنی بەرزترین پێوەری چاودێری و خزمەتگوزاری" },
        { title: "کۆمەڵگە", description: "بنیاتنانی ژینگەیەکی گەرم و خێزانی بۆ هەموو دانیشتووان" }
      ]
    },
    conclusion: {
      en: "The Home for the Elderly by Haji Ahoo exemplifies Darwazay Garmyan's dedication to giving back to the community. This project goes beyond construction—it represents a commitment to human dignity, social welfare, and the timeless Kurdish value of honoring our elders. Through this initiative, we continue to build not just structures, but a better society for all generations.",
      ar: "يجسد دار المسنين من حاجي آهو تفاني درواز كرميان في رد الجميل للمجتمع. يتجاوز هذا المشروع البناء—فهو يمثل التزاماً بالكرامة الإنسانية والرعاية الاجتماعية والقيمة الكردية الخالدة في تكريم كبار السن لدينا. من خلال هذه المبادرة، نستمر في بناء ليس فقط الهياكل، بل مجتمعاً أفضل لجميع الأجيال.",
      ku: "ماڵی بەساڵاچووان لەلایەن حاجی ئاهو نموونەیە بۆ خۆتەرخانکردنی دەروازەی گەرمیان بۆ گەڕاندنەوەی خێر بۆ کۆمەڵگە. ئەم پڕۆژەیە لە بیناسازی تێدەپەڕێت—پابەندبوون بە شایستەیی مرۆڤی و چاودێری کۆمەڵایەتی و نرخی کوردی ماوەداری ڕێزگرتن لە بەساڵاچووانمان نوێنەرایەتی دەکات. لە ڕێگەی ئەم دەستپێشخەرییەوە، بەردەوامین لە بنیاتنانی نەک تەنها بیناکان، بەڵکو کۆمەڵگەیەکی باشتر بۆ هەموو نەوەکان."
    }
  }
];
